import { render, staticRenderFns } from "./OrganizationChartContainer.vue?vue&type=template&id=06194837&"
import script from "./OrganizationChartContainer.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChartContainer.vue?vue&type=style&index=0&id=06194837&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports